import { atom, useAtom } from "jotai";
import { rechercherOperateurs } from "../../pages/Operateurs/operateursApi";
import { operateursPourSelecteur } from "../../pages/UserList/userListConfig";

// Opérateurs d'accompagnement (au moins un régime) sous la forme { id, name }
// des sélecteurs du back-office : structure d'un compte d'opérateur dans la
// fiche et la liste des utilisateurs (CE-1407). Même approche que
// useOrganizations : un atome partagé, chargé à la demande.
const operateursAtom = atom([]);

const useOperateursAccompagnement = () => {
  const [operateurs, setOperateurs] = useAtom(operateursAtom);

  const onGetOperateurs = () => {
    rechercherOperateurs({ page: 1, parPage: 200, avecRegimeSeulement: true }).then(
      (reponse) => setOperateurs(operateursPourSelecteur(reponse)),
      () => {}
    );
  };

  return { operateurs, onGetOperateurs };
};

export default useOperateursAccompagnement;
